/* ==========================================================================
   Page navigation loader
   Muestra un overlay de carga al iniciar una navegación real a otra página.
   No interfiere con filtros/orden/paginación AJAX (misma ruta), anclas,
   enlaces externos, nueva pestaña, carrito, búsqueda predictiva ni quickview.
   ========================================================================== */
(function () {
	'use strict';

	var overlay = document.getElementById('PageNavLoader');
	if (!overlay) return;

	/* Retardo antes de mostrar: si la página responde rápido, no parpadea. */
	var SHOW_DELAY = 180;
	/* Red de seguridad: si la navegación se cancela, no dejar el overlay pegado. */
	var SAFETY_TIMEOUT = 10000;

	var showTimer = null;
	var safetyTimer = null;
	var shown = false;

	function show() {
		if (shown) return;
		shown = true;
		overlay.classList.add('is-active');
		overlay.setAttribute('aria-hidden', 'false');
		safetyTimer = window.setTimeout(hide, SAFETY_TIMEOUT);
	}

	function hide() {
		shown = false;
		window.clearTimeout(showTimer);
		window.clearTimeout(safetyTimer);
		showTimer = safetyTimer = null;
		overlay.classList.remove('is-active');
		overlay.setAttribute('aria-hidden', 'true');
	}

	function scheduleShow() {
		if (showTimer || shown) return;
		showTimer = window.setTimeout(show, SHOW_DELAY);
	}

	/* --- ¿Este clic debe disparar el overlay? ----------------------------- */
	function shouldTrigger(event, anchor) {
		if (event.defaultPrevented) return false;
		if (event.button !== 0) return false; /* solo clic izquierdo */
		if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;

		if (anchor.target && anchor.target !== '_self') return false;
		if (anchor.hasAttribute('download')) return false;
		if (anchor.hasAttribute('data-no-loader')) return false;

		var rel = (anchor.getAttribute('rel') || '').toLowerCase();
		if (rel.indexOf('external') !== -1) return false;

		var href = anchor.getAttribute('href');
		if (!href) return false;
		if (/^(mailto:|tel:|sms:|javascript:|#)/i.test(href)) return false;

		/* Componentes que gestionan su propia navegación / AJAX */
		if (anchor.closest('.facets, facet-filters-form, predictive-search, .predictive-search, cart-drawer, .cart-drawer, [data-no-loader]')) {
			return false;
		}

		var url;
		try {
			url = new URL(anchor.href, window.location.href);
		} catch (e) {
			return false;
		}

		if (url.origin !== window.location.origin) return false; /* externo */

		/* Misma ruta (solo cambian query/hash) = filtro, orden, paginación o
		   ancla → lo gestiona el tema sin recarga completa. No mostrar. */
		if (url.pathname === window.location.pathname) return false;

		return true;
	}

	document.addEventListener(
		'click',
		function (event) {
			var anchor = event.target && event.target.closest
				? event.target.closest('a[href]')
				: null;
			if (!anchor) return;
			if (!shouldTrigger(event, anchor)) return;
			scheduleShow();
		},
		false
	);

	/* Envíos de formulario que recargan (búsqueda, login, etc.) */
	document.addEventListener(
		'submit',
		function (event) {
			var form = event.target;
			if (!form || event.defaultPrevented) return;
			if (form.hasAttribute('data-no-loader')) return;
			var method = (form.getAttribute('method') || 'get').toLowerCase();
			/* Los formularios AJAX del tema (carrito, facetas, predictiva) */
			if (form.closest('.facets, facet-filters-form, predictive-search, cart-drawer, [data-no-loader]')) return;
			if (method === 'get' || method === 'post') scheduleShow();
		},
		false
	);

	/* Ocultar al volver con el botón atrás (bfcache) o al restaurar la página. */
	window.addEventListener('pageshow', hide);
	/* Si el usuario cancela la salida o vuelve el foco, limpiar. */
	window.addEventListener('pagehide', function () {
		/* la navegación ya ocurrió; el nuevo documento parte sin overlay */
	});
})();
